
import AIArticleForm from "@/components/sections/admin/AIArticleForm";
import { useState } from "react";

const AdminAIArticles = () => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      <div className="container py-8 md:py-24">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold mb-8">
            Generate Articles with AI
          </h1>
          <AIArticleForm setIsLoading={setIsLoading} />
        </div>
      </div>
    </div>
  );
};

export default AdminAIArticles;
